// extracted by mini-css-extract-plugin
export default {"chatContainer":"Chat_chatContainer__3T6p5","noGameContainer":"Chat_noGameContainer__l3ct7"};